<template>
<div class="shopMobKnowledge mpadding-64 overflow mobView">
    <div class="title-bar">
        <div class="titlename"><span v-if="setting.isdisplaytitle" class="blod">{{setting.titlename}}</span></div>
        <div class="displayall"><span v-if="setting.isdisplayall">查看更多</span></div>
    </div>
    <div v-if="setting.liststyle === 'detail'" class="detail">
        <div class="mmargin-96 detail-list" v-for="(data,index) in setting.datalist" :key="index">
            <div class="detail-img">
                <img v-lazy="data.furl ? data.furl : img" alt="">
                <div class="label">{{data.kmctype | kmctype}}</div>
                <div class="duration" v-if="data.kmctype == 4">{{data.duration}}</div>
            </div>
            <div class="detail-summary">
                <div class="detail-info">
                    <div class="title">{{data.objectname}}</div>
                    <div class="summary" v-if="data.kmctype == 5" v-html="data.description"></div>
                </div>
                <div class="other-info">
                    <div>
                        <div v-if="!data.saleprice" class="freeprice">免费</div>
                        <div v-else><span class="saleprice">{{data.saleprice}}</span><span class="uprice" v-if="data.uprice !== 0 && data.uprice !== '0.00'">¥{{data.uprice}}</span></div>
                    </div>
                    <div>
                        <span class="viewcount"><i class="icon_viewcount"></i>{{data.viewcount}}123</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="setting.liststyle === 'bigimage'" class="bigimage">
        <div class="mmargin-96 bigimage-list box-shadow" v-for="(data,index) in setting.datalist" :key="index">
            <div class="bigimage-img">
                <img v-lazy="data.furl ? data.furl : img" alt="">
                <div class="label">{{data.kmctype | kmctype}}</div>
                <span class="viewcount"><i class="icon_viewcount"></i>{{data.viewcount}}123</span>
                <div class="duration" v-if="data.kmctype == 4">{{data.duration}}</div>
            </div>
            <div class="bigimage-summary">
                <div class="detail-info">
                    <div class="title">{{data.objectname}}</div>
                    <div class="summary" v-if="data.kmctype == 5" v-html="data.description"></div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="setting.liststyle === 'smallimage'" class="smallimage">
        <div class="mmargin-96 smallimage-list box-shadow" v-for="(data,index) in setting.datalist" :key="index">
            <div class="smallimage-img">
                <img v-lazy="data.furl ? data.furl : img" alt="">
                <div class="label">{{data.kmctype | kmctype}}</div>
                <span class="viewcount"><i class="icon_viewcount"></i>{{data.viewcount}}123</span>
                <div class="duration" v-if="data.kmctype == 4">{{data.duration}}</div>
            </div>
            <div class="smallimage-summary">
                <div class="detail-info">
                    <div class="title">{{data.objectname}}</div>
                </div>
                <div class="other-info">
                    <div>
                        <div v-if="!data.saleprice" class="freeprice">免费</div>
                        <div v-else><span class="saleprice">{{data.saleprice}}</span><span class="uprice" v-if="data.uprice !== 0 && data.uprice !== '0.00'">¥{{data.uprice}}</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    name: 'knowledge',
    data() {
        return {
            img: require('../../../../../common/images/shop/banner.png')
        }
    },
    props: ['setting'],
    mounted() {},
    methods: {},
    filters: {
        kmctype: function (value) {
            switch (value) {
            case 1: return '图文'
            case 2: return '报告'
            case 4: return '视频'
            case 5: return '专题'
            }
        }
    },
    watch: {},
    computed: {
        ...mapGetters([
            'shopMob',
            'selectCom'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.shopMobKnowledge {
    min-height: 100px;
    .detail{
    }
    .bigimage{
    }
    .smallimage{
    }
    .titlename{
        width: 11rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;   
    }
}
</style>
